import React from "react"
import { useRouter } from "next/router"
import styled from "styled-components"
import ListCard from "./ListCard"
import { themeGet } from "@styled-system/theme-get"
import { useTranslation } from "next-i18next"

export default function HotArticle({ data }) {
  const { locale } = useRouter()
  const { t } = useTranslation("common")
  // const Articles = data.filter(p => {
  //   const matchArray = p.attributes.title.match(new RegExp("a", "gi"))
  //   return !!matchArray
  // })
  const Articles = data.filter(article =>
    article.attributes.tags?.data.some(
      ({ attributes }) =>
        attributes.name === "Hot" ||
        attributes.name === "熱門文章" ||
        attributes.name === "热门文章"
    )
  )
  const hotArticles = Articles.slice(0, 5)

  return (
    <Wrapper>
      <TitleWrapper>
        <h3>{t("hot-articles")}</h3>
      </TitleWrapper>
      <CardsList>
        {hotArticles?.map(e => (
          <ListCard
            title={e.attributes.title}
            link={`${locale === "en" ? "" : `/${locale}`}/blog/${
              e.attributes["blog_identifier"].data.attributes.Identifier
            }`}
            img={
              e?.attributes?.cover_image?.data?.attributes?.formats?.medium
                ?.url || e?.attributes?.cover_image?.data?.attributes?.url // GIF
            }
            alt="123"
            key={e.id}
          />
        ))}
      </CardsList>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 30px;
  position: relative;
`

const TitleWrapper = styled.div`
  height: 30px;
  h3 {
    font-size: 24px;
    font-weight: 900;

    // margin: 0;
    // margin-left: 16px;
    position: relative;
  }
  // &:before {
  //   content: "";
  //   width: 100%;
  //   height: 30px;
  //   border-left: 4px solid ${themeGet("colors.primary")};
  //   position: absolute;
  //   top: 0;
  //   left: 0;
  // }
`

const CardsList = styled.div`
  display: flex;
  flex-direction: column;
  // gap: 8px;
`
